UAChangeLicenseEndDatesCtrl.$inject = [
  '$state',
  '$uibModalInstance',
  'product',
  'users',
  'domainUuid',
  'adminApi'
]

export default function UAChangeLicenseEndDatesCtrl(
  $state,
  $modalInstance,
  product,
  users,
  domainUuid,
  adminApi
) {
  this.provisioning = false
  this.showError = false
  this.errorMessage = ''

  this.templateLicenses = []
  this.userUuids = users.map(function(u) {
    return u.uuid
  })
  this.licenses = users.map(function(u) {
    var l
    if (product === 'toolkit') {
      l = u.toolkit_license
    } else if (product === 'pathways') {
      l = u.pathways_license
    }
    return l
  })
  // check if any of the licenses are null, in which case
  // prompt user to revise their selection
  this.licenseError = false
  this.currentEndDates = []
  if (this.licenses.indexOf(null) > -1 || this.licenses.indexOf(undefined) > -1) {
    this.licenseError = true
    this.showError = true
    this.errorMessage =
      'Not all users have a ' +
      product +
      ' license. Close this modal and deselect any users without a ' +
      product +
      ' license.'
  } else {
    this.templateLicenses = this.licenses.map(
      function(l) {
        if (this.currentEndDates.indexOf(l.end_date_fmt) < 0) {
          this.currentEndDates.push(l.end_date_fmt)
        }
        return {
          product: l.product,
          type: l.type,
          sub_type: l.sub_type,
          start_date_fmt: l.start_date_fmt,
          end_date_fmt: l.end_date_fmt
        }
      }.bind(this)
    )
  }

  this.provision = function(newEndDateFmt) {
    if (this.licenseError) {
      return
    }
    this.provisioning = true
    this.templateLicenses = this.templateLicenses.map(function(l) {
      l.end_date_fmt = newEndDateFmt
      return l
    })
    var actionData = {
      licenses_to_delete: this.licenses.map(function(l) {
        return l.uuid
      }),
      template_licenses: this.templateLicenses
    }
    adminApi.replaceLicensesForDomainUsers(domainUuid, this.userUuids, actionData).then(
      function(response) {
        if (response.import_uuid) {
          $modalInstance.close(response)
          $state.go('import-wizard.import-status', {
            domainUuid: domainUuid,
            importUuid: response.import_uuid
          })
        } else {
          this.showError = true
          this.errorMessage = response
        }
        this.provisioning = false
      }.bind(this),
      function(response) {
        this.showError = true
        this.errorMessage = response
        this.provisioning = false
      }.bind(this)
    )
  }
}
